import React from 'react';

const LoadingSpinner = ({ className = "", size = "lg" }) => {
  // تحديد الحجم بناءً على المعلمة size
  const sizeMap = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-24 h-24",
    "2xl": "w-32 h-32"
  };

  const sizeClass = sizeMap[size] || sizeMap.lg;

  return (
    <div className={`${sizeClass} ${className} relative`}>
      <svg
        className="animate-spin w-full h-full"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle 
          cx="50" 
          cy="50" 
          r="45" 
          fill="none" 
          strokeWidth="8" 
          stroke="currentColor" 
          strokeOpacity="0.1" 
        />
        <path
          d="M 50 5 A 45 45 0 0 1 95 50"
          fill="none"
          strokeWidth="8"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;